import { BodyLarge, Heading2 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import React, { MutableRefObject, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

import { ContactAgencyForm } from '@/components/ContactAgencyForm'
import HouseRent from '@/components/Icon/HouseRent'
import { ContextValue } from '@/context/Cities'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'

import { mobileContactUsAgencyNameWrapper } from '../styles.css'

import MobileButtons from './MobileButtons'
import { agencyAddressWrapper } from './styles.css'

type Props = {
  cities: ContextValue
  handleOpenDetailFormModal: (reopenMap: boolean) => (event: React.SyntheticEvent<HTMLElement>) => void
  handleTrackingCallAgency: (eventCategory: string) => void
  property: ListingCate
  similarPropertiesLength: number
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}

const MobileContactUs: React.FC<Props> = ({
  cities,
  handleOpenDetailFormModal,
  handleTrackingCallAgency,
  property,
  similarPropertiesLength,
  similarPropertiesRef,
}) => {
  const { t } = useTranslation()
  const [areButtonsVisible, setAreButtonsVisible] = useState(false)
  const { inView, ref: refInView } = useInView()

  useEffect(() => {
    document.addEventListener('scroll', () => {
      setAreButtonsVisible(window.scrollY > 100)
    })
    return () =>
      document.removeEventListener('scroll', () => {
        setAreButtonsVisible(window.scrollY > 100)
      })
  }, [])

  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  return (
    <>
      <div
        className={sprinkles({
          display: 'flex',
          gap: 's',
          justifyContent: 'space-between',
          paddingBottom: '2xl',
        })}
        data-component="agency-contact-form"
      >
        <div className={sprinkles({ flexShrink: 0 })}>
          <img alt="" loading="lazy" src={`${imageBasePath}/images/concepts/clouds-left-small.svg`} width={75} />
        </div>
        <div
          className={sprinkles({
            paddingY: 'l',
            textAlign: 'center',
          })}
        >
          <Heading2 className={sprinkles({ paddingBottom: 's' })}>{t('listing-detail:form-header.title')}</Heading2>
          <BodyLarge>
            {t(
              property.contactInfo.ownedByCasavo
                ? 'listing-detail:form-header.subtitle_casavo'
                : 'listing-detail:form-header.subtitle_agency'
            )}
          </BodyLarge>
        </div>
        <div className={sprinkles({ flexShrink: 0 })}>
          <img alt="" loading="lazy" src={`${imageBasePath}/images/concepts/clouds-right-small.svg`} width={75} />
        </div>
      </div>

      {property.detail.casavoDirectSale && (
        <div ref={refInView} id="contactForm">
          <ContactAgencyForm
            cities={cities}
            property={property}
            similarPropertiesLength={similarPropertiesLength}
            similarPropertiesRef={similarPropertiesRef}
          />
        </div>
      )}

      {!property.contactInfo.ownedByCasavo && (
        <div
          className={sprinkles({
            paddingBottom: 's',
            textAlign: 'center',
          })}
        >
          <p className={mobileContactUsAgencyNameWrapper}>
            <HouseRent className={sprinkles({ marginRight: 's' })} />
            {property.contactInfo.agencyName}
          </p>
          <p className={agencyAddressWrapper}>{property.contactInfo.agencyAddress}</p>
        </div>
      )}

      {areButtonsVisible && (
        <MobileButtons
          handleOpenDetailFormModal={handleOpenDetailFormModal}
          handleTrackingCallAgency={handleTrackingCallAgency}
          inView={inView}
          property={property}
          similarPropertiesRef={similarPropertiesRef}
        />
      )}
    </>
  )
}

export default MobileContactUs
